import { render, staticRenderFns } from "./GameStatistics.vue?vue&type=template&id=4434e1f4&scoped=true"
import script from "./GameStatistics.vue?vue&type=script&lang=js"
export * from "./GameStatistics.vue?vue&type=script&lang=js"
import style0 from "./GameStatistics.vue?vue&type=style&index=0&id=4434e1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4434e1f4",
  null
  
)

export default component.exports